module.exports = __webpack_public_path__ + "img/cvc.8087fe3f.svg";